import { BaseSvgIcon } from 'components/design-system/kickoff-icons/base-svg-icon'

export default function StarIcon({
  className = '',
  lgKey = '',
  startColor = '#4DD182',
  stopColor = '#009946',
  size,
}) {
  return (
    <BaseSvgIcon
      viewBox="0 0 10 10"
      fill="none"
      className={className}
      size={size}>
      <path
        d="M3.57658 1.70419L3.41273 1.99812C3.23276 2.32097 3.14278 2.48239 3.00247 2.5889C2.86217 2.69541 2.68743 2.73495 2.33794 2.81402L2.01977 2.88601C0.789928 3.16428 0.175009 3.30341 0.0287104 3.77387C-0.117587 4.24432 0.301625 4.73454 1.14005 5.71496L1.35696 5.96861C1.59521 6.24722 1.71434 6.38652 1.76793 6.55886C1.82152 6.7312 1.80351 6.91706 1.76749 7.28878L1.7347 7.6272C1.60794 8.9353 1.54456 9.58935 1.92757 9.88011C2.31059 10.1709 2.88633 9.90577 4.03783 9.37559L4.03784 9.37558L4.33574 9.23842L4.33576 9.23841C4.66297 9.08776 4.82658 9.01242 5 9.01242C5.17343 9.01242 5.33704 9.08776 5.66426 9.23842L5.96216 9.37559L5.96218 9.37559C7.11367 9.90578 7.68941 10.1709 8.07243 9.88011C8.45544 9.58935 8.39206 8.93531 8.2653 7.62722V7.62721L8.23251 7.28878L8.2325 7.28872C8.19649 6.91705 8.17848 6.73118 8.23207 6.55886C8.28566 6.38652 8.40479 6.24722 8.64304 5.96861L8.85995 5.71496C9.69838 4.73454 10.1176 4.24432 9.97129 3.77387C9.82499 3.30341 9.21007 3.16428 7.98023 2.88601L7.66206 2.81402C7.31257 2.73495 7.13783 2.69541 6.99753 2.5889C6.85722 2.48239 6.76724 2.32097 6.58727 1.99813L6.42342 1.70419L6.42341 1.70418C5.79009 0.56806 5.47343 0 5 0C4.52657 0 4.20991 0.568064 3.57659 1.70418L3.57658 1.70419Z"
        fill={`url(#paint0_linear_2084_32_${lgKey}`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_2084_32_${lgKey}`}
          x1="10"
          y1="5"
          x2="0"
          y2="5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
      </defs>
    </BaseSvgIcon>
  )
}
